/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import { Button, Divider, IconButton, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { length } from 'redux-form-validators';
import clsx from 'clsx';
import { CloseRounded } from '@material-ui/icons';

import { CustomStepper } from '../CustomStepper';

import LinkedIn from 'assets/icons/link.svg';
import Boost from 'assets/boost.png';
import { useLocale } from 'shared/hooks/useLocale/useLocale';
import { StudentLoginHeader } from 'app/studentLoginPage/studentLoginHeader/studentLoginHeader';
import { useStyles } from './HighSchoolSelfRegistration.styles';
import { MainHeading } from 'app/avUserRoot/collabloratorUpload/uploadMedia/eventInformations/EventInformation.styles';
import { InputField } from 'shared/components/controls/input/InputField';
import { SelfRegistrationProps } from './HighSchoolSelfRegistration.types';
import { Form } from 'shared/components/form/Form';
import { email } from 'shared/validators';
import { CheckboxField } from 'shared/components/controls';
import { RecaptchaField } from 'shared/components/controls/recaptchaField/RecaptchaField';
import { Loader } from 'shared/components';
import { OverlayMessage } from './OverlayMessage';

export const SelfRegistrationPage = ({
  onSubmit,
  activeStep,
  instituteLogo,
  isCollective,
  isRetail,
  isLoading,
  queryParamKeys,
  isAllowForAmazonMusic,
  handleOnSubmitLinkedIn,
  isFromSelfOnBoard,
  institutionId,
}: SelfRegistrationProps) => {
  const styles = useStyles({});
  const { formatMessage } = useLocale();
  const { breakpoints } = useTheme();

  const [showLinkedInFlow, setShowLinkedInFlow] = useState<boolean>(false);
  const [showEmailFlow, setShowEmailFlow] = useState<boolean>(false);

  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const initialValues = {
    isAllowForMarketing: true,
  };

  const handleClose = () => {
    setShowLinkedInFlow(false);
    setShowEmailFlow(false);
  };

  const isShowBlock = institutionId === process.env.REACT_APP_BLOCK_REGISTER_INSTITUTION_ID;

  return (
    <>
      {isShowBlock && (
        <OverlayMessage message="Your ceremony video is currently processing. Swing back in 3 hours to get your clip." />
      )}
      {(queryParamKeys === 'instituitionId' ? activeStep === 1 : activeStep === 0) && (
        <div className={styles.mainContainer}>
          <StudentLoginHeader />
          <div className={styles.imgContainer}>
            {instituteLogo && <img src={instituteLogo} alt="institute logo" className={styles.logoImage} />}
          </div>
          <div className={styles.container}>
            <div className={styles.cardWrapper}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <CustomStepper
                  isCollective={isCollective}
                  isRetail={isRetail}
                  activeStep={activeStep}
                  isAllowForAmazonMusic={isAllowForAmazonMusic}
                />
                <Typography className={styles.titleContainer}>
                  {formatMessage({ id: 'highSchool.register_welcome' })}
                </Typography>
                <Typography className={styles.subTitle}>
                  {formatMessage({ id: 'highSchool.register_welcome_subtitle' })}
                </Typography>
                <Typography className={styles.supportText}>
                  <div>
                    Already registered ?{' '}
                    <a href="https://stageclip.com/student-support/" target="_blank" rel="noopener noreferrer">
                      Contact us{' '}
                    </a>
                    to change your clip submission. Avoid re-registering to prevent delays.
                  </div>
                </Typography>
              </div>
              <div className={styles.card}>
                {/* linked in flow */}
                <div className={styles.cardHeader}>
                  <div>
                    <MainHeading className={styles.header}>
                      {formatMessage({ id: 'highSchool.register_title' })}
                    </MainHeading>
                  </div>
                  {(showLinkedInFlow || showEmailFlow) && (
                    <div>
                      <IconButton className={styles.closeIcon} onClick={() => handleClose()}>
                        <CloseRounded />
                      </IconButton>
                    </div>
                  )}
                </div>

                {!showEmailFlow && (
                  <>
                    <div>
                      <Button
                        type="submit"
                        size="large"
                        fullWidth
                        className={styles.linkedinButtonContainer}
                        onClick={() => setShowLinkedInFlow(!showLinkedInFlow)}
                        disabled={showLinkedInFlow}
                      >
                        <span className={styles.linkedinContent}>
                          <span className={styles.linkedinIcon}>
                            <img src={LinkedIn} alt="linkedin" />
                          </span>
                          <span className={styles.linkedinText}>
                            {isFromSelfOnBoard ? 'Get Free Clips via LinkedIn' : 'Get Clips via LinkedIn'}
                          </span>
                        </span>
                      </Button>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '0.5rem',
                          marginTop: '-0.8rem',
                          marginBottom: '0.5rem',
                          flexWrap: 'wrap', // allows text to move to next line if needed
                          textAlign: 'center',
                        }}
                      >
                        <img src={Boost} alt="boost" width={25} height={25} />
                        <div className={styles.boostTitle}>Profile Boost - </div>
                        <div className={styles.boostSubTitle}>your clip appears in your LinkedIn feed!</div>
                      </div>

                      {!showLinkedInFlow && (
                        <>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Divider style={{ flexGrow: 1 }} />
                            <Typography style={{ margin: '1rem', whiteSpace: 'nowrap' }}>OR</Typography>
                            <Divider style={{ flexGrow: 1 }} />
                          </div>
                          <div className={styles.registerButtonContainer}>
                            <Button
                              variant="text"
                              type="submit"
                              size="small"
                              className={styles.regBtn}
                              onClick={() => setShowEmailFlow(!showEmailFlow)}
                            >
                              {isLoading ? (
                                <Loader />
                              ) : (
                                <>
                                  {isMobile && !isAllowForAmazonMusic
                                    ? formatMessage({ id: 'highSchool.register_button_email' })
                                    : formatMessage({ id: 'highSchool.register_button_email' })}
                                </>
                              )}
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}

                {showLinkedInFlow && (
                  <>
                    <Form
                      onSubmit={handleOnSubmitLinkedIn}
                      initialValues={initialValues}
                      errorSeparator={2}
                      render={({ handleSubmit, invalid }) => (
                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
                          <InputField
                            label={formatMessage({ id: 'highSchool.graduate_email' })}
                            type="email"
                            size="small"
                            name="email"
                            fullWidth
                            placeholder="Enter your email"
                            validate={[email()]}
                            required
                            className={styles.textLabel}
                          />
                          <InputField
                            label="Degree title, course name or honors (Optional)"
                            type="text"
                            size="small"
                            name="subtitle"
                            fullWidth
                            placeholder="Enter details"
                            validate={[length({ max: 90 })]}
                            className={styles.textLabel}
                            classes={{ root: styles.textFieldHounerRoot }}
                          />

                          <Button
                            type="submit"
                            size="large"
                            className={styles.buttonContainer}
                            disabled={isLoading || invalid}
                          >
                            {isLoading ? <Loader /> : 'Submit'}
                          </Button>
                        </form>
                      )}
                    />
                  </>
                )}
                {/* normal flow */}
                {showEmailFlow && (
                  <>
                    <Form
                      onSubmit={onSubmit}
                      initialValues={initialValues}
                      errorSeparator={2}
                      render={({ handleSubmit, invalid }) => (
                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
                          <InputField
                            label={formatMessage({ id: 'highSchool.graduate_first_name' })}
                            type="text"
                            size="small"
                            name="firstName"
                            fullWidth
                            placeholder="Enter your first name as announced"
                            required
                            validate={[length({ max: 50 })]}
                            className={styles.textLabel}
                            classes={{ root: styles.textFieldRoot }}
                          />
                          <InputField
                            label={formatMessage({ id: 'highSchool.graduate_last_name' })}
                            type="text"
                            size="small"
                            name="lastName"
                            fullWidth
                            placeholder="Enter your last name as announced"
                            required
                            validate={[length({ max: 50 })]}
                            className={styles.textLabel}
                            classes={{ root: styles.textFieldRoot }}
                          />
                          <InputField
                            label={formatMessage({ id: 'highSchool.graduate_email' })}
                            type="email"
                            size="small"
                            name="email"
                            fullWidth
                            placeholder="Enter your email"
                            validate={[email()]}
                            required
                            className={styles.textLabel}
                          />
                          <InputField
                            label="Degree title, course name or honors (Optional)"
                            type="text"
                            size="small"
                            name="subtitle"
                            fullWidth
                            placeholder="Enter details"
                            validate={[length({ max: 90 })]}
                            className={styles.textLabel}
                            classes={{ root: styles.textFieldHounerRoot }}
                          />

                          <div className={styles.recaptcha}>
                            <RecaptchaField name="token" />
                          </div>
                          <Button
                            type="submit"
                            size="large"
                            className={styles.buttonContainer}
                            disabled={isLoading || invalid}
                          >
                            {isLoading ? (
                              <Loader />
                            ) : (
                              <>
                                {isMobile && !isAllowForAmazonMusic
                                  ? formatMessage({ id: 'highSchool.register_button' })
                                  : formatMessage({ id: 'highSchool.register_button' })}
                              </>
                            )}
                          </Button>

                          {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Divider style={{ flexGrow: 1 }} />
                            <Typography style={{ margin: '1rem', whiteSpace: 'nowrap' }}>OR</Typography>
                            <Divider style={{ flexGrow: 1 }} />
                          </div>

                          <Button
                            type="submit"
                            size="large"
                            className={styles.linkedinButtonContainer}
                            disabled={!invalid}
                            onClick={() => setShowLinkedInFlow(true)}
                          >
                            {formatMessage({ id: 'highSchool.linkedin_register_button' })}{' '}
                            <img src={LinkedIn} style={{ marginLeft: '0.4rem' }} width={100} alt="linkedin" />
                          </Button> */}

                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              textAlign: 'center',
                              marginTop: '16px',
                            }}
                          >
                            <Typography className={styles.emailClipsReadyTitle}>
                              {formatMessage({ id: 'highSchool.register_subtitle' })}
                            </Typography>
                            <Typography className={styles.emailClipsReadySubTitle}>
                              {formatMessage({ id: 'highSchool.register_second_subtitle' })}
                            </Typography>
                            <div className={styles.checkboxContainer}>
                              <CheckboxField
                                name="isAllowForMarketing"
                                size="small"
                                label={formatMessage({ id: 'highSchool.register_promotion_subtitle' })}
                                className={clsx(
                                  isAllowForAmazonMusic ? styles.bottomContainerAmazon : styles.bottomContainer,
                                )}
                              />
                              <a
                                href="https://stageclip.com/privacy-policy/"
                                target="_black"
                                style={{
                                  textDecoration: '',
                                  color: '#71717A',
                                  marginLeft: '-0.3rem',
                                  fontSize: '10px',
                                }}
                              >
                                Privacy policy
                              </a>
                            </div>
                          </div>
                        </form>
                      )}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
